import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/components/sections/ai-assistant-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/components/sections/banner-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/components/sections/co-founder-features.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/components/sections/co-founder-testimonials.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/components/sections/hero-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HoverEffect"] */ "/vercel/path0/apps/web/src/components/ui/card-hover-effect.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["InfiniteMovingCards"] */ "/vercel/path0/apps/web/src/components/ui/infinite-moving-cards.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/components/waitlist-button/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/src/components/magicui/box-reveal.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/src/components/ui/background-beams.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TooltipProvider","Tooltip","TooltipTrigger","TooltipContent"] */ "/vercel/path0/packages/ui/src/components/ui/tooltip.tsx");
